export const RESOURCE_TYPE_SERVICEDESK_PORTAL_WIDGET_DISMISSED =
	'SERVICEDESK_PORTAL_WIDGET_DISMISSED';

export const JSM_PORTAL_WIDGET_USER_PROPERTY = 'eoc-jsm-servicedesk-portal-widget';
